import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What types of equipment do you service?",
      answer: "Our network of technicians specializes in all types of commercial kitchen equipment including ovens, refrigerators, dishwashers, fryers, grills, mixers, and more. We cover both repairs and maintenance services."
    },
    {
      question: "How quickly can I get service?",
      answer: "We offer 24/7 emergency repair services. For non-emergency repairs, we typically connect you with a service provider within 24 hours. Many of our partners offer same-day service for urgent repairs."
    },
    {
      question: "Are your service providers certified?",
      answer: "Yes, all service providers in our network are thoroughly vetted, licensed, and certified. We verify their credentials, experience, and customer satisfaction ratings before adding them to our platform."
    },
    {
      question: "What areas do you cover?",
      answer: "We currently service major metropolitan areas across the United States, with coverage in over 50 cities. Enter your location in our search to find providers in your area."
    },
    {
      question: "Do you offer warranty on repairs?",
      answer: "Yes, all repairs through our platform come with a satisfaction guarantee. The specific warranty terms may vary by service provider and type of repair."
    },
    {
      question: "How does pricing work?",
      answer: "Pricing varies based on the type of equipment, repair needed, and your location. You'll receive detailed quotes from service providers before any work begins, allowing you to compare options."
    },
    {
      question: "Can I schedule regular maintenance?",
      answer: "Yes, many of our service providers offer preventive maintenance plans. This can help prevent unexpected breakdowns and extend the life of your equipment."
    },
    {
      question: "What happens if I'm not satisfied with the service?",
      answer: "Customer satisfaction is our priority. If you're not satisfied with the service, contact our support team immediately. We'll work with you and the service provider to resolve any issues."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="hero-section">
        <h1>Frequently Asked Questions</h1>
        <p className="subtitle">Find answers to common questions about our services</p>
      </div>

      <div className="content-section">
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-card ${openIndex === index ? 'open' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="question">
                <h3>{faq.question}</h3>
                <div className="icon">{openIndex === index ? '−' : '+'}</div>
              </div>
              <div className="answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="support-section">
          <h2>Still Have Questions?</h2>
          <p>Our support team is here to help you 24/7</p>
          <div className="support-options">
            <a href="/contact" className="support-card">
              <div className="icon">📞</div>
              <h3>Call Support</h3>
              <p>(800) 123-4567</p>
            </a>
            <a href="/contact" className="support-card">
              <div className="icon">✉️</div>
              <h3>Email Us</h3>
              <p>support@hotsiderepairs.com</p>
            </a>
          </div>
        </div>
      </div>

      <style>
        {`
          .faq-page {
            min-height: 100vh;
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #fff;
          }

          .hero-section {
            padding: 6rem 2rem;
            text-align: center;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-bottom: 4px solid #ff6b35;
            position: relative;
          }

          .hero-section h1 {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .subtitle {
            font-size: 1.5rem;
            color: rgba(255,255,255,0.9);
            max-width: 800px;
            margin: 0 auto;
            font-weight: 300;
          }

          .content-section {
            max-width: 1000px;
            margin: 0 auto;
            padding: 4rem 2rem;
          }

          .faq-grid {
            display: grid;
            gap: 1.5rem;
            margin-bottom: 4rem;
          }

          .faq-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            padding: 1.5rem;
            cursor: pointer;
            border: 2px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .faq-card:hover {
            transform: translateY(-2px);
            border-color: rgba(255, 107, 53, 0.3);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.1);
          }

          .question {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 1rem;
          }

          .question h3 {
            font-size: 1.25rem;
            color: #fff;
            margin: 0;
            font-weight: 600;
            letter-spacing: 0.5px;
          }

          .icon {
            font-size: 1.5rem;
            color: #ff6b35;
            font-weight: 600;
            transition: transform 0.3s ease;
          }

          .answer {
            max-height: 0;
            overflow: hidden;
            transition: all 0.3s ease;
          }

          .faq-card.open .answer {
            max-height: 300px;
            margin-top: 1rem;
          }

          .answer p {
            color: rgba(255,255,255,0.9);
            line-height: 1.6;
            font-size: 1.1rem;
            margin: 0;
          }

          .support-section {
            text-align: center;
            padding: 3rem;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            border: 2px solid rgba(255,255,255,0.1);
          }

          .support-section h2 {
            font-size: 2.5rem;
            color: #ff6b35;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .support-section > p {
            font-size: 1.25rem;
            color: rgba(255,255,255,0.9);
            margin-bottom: 2rem;
          }

          .support-options {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 2rem;
            margin-top: 2rem;
          }

          .support-card {
            background: linear-gradient(145deg, #383838, #2a2a2a);
            padding: 2rem;
            border-radius: 8px;
            text-decoration: none;
            color: #fff;
            border: 1px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .support-card:hover {
            transform: translateY(-5px);
            border-color: rgba(255, 107, 53, 0.3);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.1);
          }

          .support-card .icon {
            font-size: 2rem;
            margin-bottom: 1rem;
          }

          .support-card h3 {
            font-size: 1.25rem;
            margin-bottom: 0.5rem;
            color: #fff;
          }

          .support-card p {
            color: #ff6b35;
            font-size: 1.1rem;
          }

          @media (max-width: 768px) {
            .hero-section h1 {
              font-size: 2.5rem;
            }

            .subtitle {
              font-size: 1.25rem;
            }

            .content-section {
              padding: 2rem 1rem;
            }

            .question h3 {
              font-size: 1.1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default FAQ;